(() => {
  const REMEMBER_EMAIL = 'username';
  const REMEMBER_FLAG = 'checkbox';

  const storage = {
    get(key) {
      try {
        return localStorage.getItem(key) || '';
      } catch (error) {
        return '';
      }
    },
    set(key, value) {
      try {
        localStorage.setItem(key, value);
      } catch (error) {}
    },
  };

  const showError = (control, message) => {
    const field = control.closest('.field-3dids') || control.parentElement;
    const error = field.querySelector('.field-3dids__error');
    control.classList.toggle('field-3dids__input--invalid', Boolean(message));
    if (!error) return;
    if (message) error.textContent = message;
    error.classList.toggle('is-visible', Boolean(message));
  };

  const initTabs = (root) => {
    const tabs = root.querySelectorAll('[data-tab-target]');
    const panels = root.querySelectorAll('[data-tab-panel]');

    const show = (key) => {
      tabs.forEach((tab) => tab.setAttribute('aria-selected', String(tab.dataset.tabTarget === key)));
      panels.forEach((panel) => {
        panel.hidden = panel.dataset.tabPanel !== key;
      });
    };

    tabs.forEach((tab) => tab.addEventListener('click', () => show(tab.dataset.tabTarget)));
  };

  const initLogin = (panel) => {
    const views = panel.querySelectorAll('[data-view]');
    const showView = (name) => {
      views.forEach((view) => {
        view.hidden = view.dataset.view !== name;
      });
    };

    panel.querySelectorAll('[data-show-view]').forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        showView(trigger.dataset.showView);
      });
    });

    if (window.location.hash === '#recover') showView('recover');

    const remember = panel.querySelector('[data-remember-me]');
    const email = panel.querySelector('#CustomerEmail');
    if (!remember || !email) return;

    if (storage.get(REMEMBER_FLAG)) {
      remember.checked = true;
      email.value = storage.get(REMEMBER_EMAIL);
    }

    email.closest('form').addEventListener('submit', () => {
      if (remember.checked && email.value !== '') {
        storage.set(REMEMBER_EMAIL, email.value);
        storage.set(REMEMBER_FLAG, 'true');
      } else {
        storage.set(REMEMBER_EMAIL, '');
        storage.set(REMEMBER_FLAG, '');
      }
    });
  };

  const initRegister = (panel) => {
    const form = panel.querySelector('form');
    const fields = panel.querySelector('[data-register-fields]');
    if (!form || !fields) return;

    const messages = {
      required: fields.dataset.messageRequired,
      phone: fields.dataset.messagePhone,
      password: fields.dataset.messagePassword,
    };
    const required = [...form.querySelectorAll('[data-required]')];
    const password = form.querySelector('#RegisterForm-password');
    const confirm = form.querySelector('[data-confirm]');
    const phone = form.querySelector('[data-phone]');
    const policy = form.querySelector('[data-policy]');
    const policyError = form.querySelector('[data-error-for="accepted-policy"]');

    const checkRequired = (control) => {
      const empty = control.value.trim() === '';
      showError(control, empty ? messages.required : '');
      return !empty;
    };

    const checkPhone = () => {
      if (phone.value.trim() === '') return checkRequired(phone);
      const valid = /^\d+$/.test(phone.value);
      showError(phone, valid ? '' : messages.phone);
      return valid;
    };

    const checkConfirm = () => {
      if (!checkRequired(confirm)) return false;
      const same = password.value === confirm.value;
      showError(confirm, same ? '' : messages.password);
      return same;
    };

    required.forEach((control) => {
      const handler = control === phone ? checkPhone : control === confirm ? checkConfirm : () => checkRequired(control);
      control.addEventListener('input', handler);
      control.addEventListener('change', handler);
    });

    policy.addEventListener('change', () => policyError.classList.toggle('is-visible', !policy.checked));

    form.addEventListener('submit', (event) => {
      const results = required.map((control) => {
        if (control === phone) return checkPhone();
        if (control === confirm) return checkConfirm();
        return checkRequired(control);
      });
      const accepted = policy.checked;
      policyError.classList.toggle('is-visible', !accepted);

      if (results.every(Boolean) && accepted) return;
      event.preventDefault();
      const firstInvalid = form.querySelector('.field-3dids__input--invalid');
      if (firstInvalid) firstInvalid.focus();
    });
  };

  const init = () => {
    document.querySelectorAll('[data-customer-access]').forEach((root) => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      initTabs(root);
      root.querySelectorAll('[data-tab-panel="login"]').forEach(initLogin);
      root.querySelectorAll('[data-tab-panel="register"]').forEach(initRegister);
    });
  };

  init();
  document.addEventListener('shopify:section:load', init);
})();
